// import React, { useState } from "react";

// const navLinks = ["Home", "About", "Services", "Doctors", "Pricing", "News", "Contact"];

// const Navbar = () => {
//   const [menuOpen, setMenuOpen] = useState(false);

//   const scrollTo = (id) => {
//     const el = document.getElementById(id.toLowerCase());
//     if (el) el.scrollIntoView({ behavior: "smooth" });
//     setMenuOpen(false);
//   };

//   return (
//     <nav className="bg-white shadow-md sticky top-0 z-50">
//       <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-18 py-4">
//         {/* Logo */}
//         <div className="font-playfair text-2xl font-bold text-blue-900">
//           Hela<span className="text-teal-600">Doc</span>
//         </div>

//         {/* Desktop Nav */}
//         <ul className="hidden md:flex gap-1 list-none">
//           {navLinks.map((link) => (
//             <li key={link}>
//               <button
//                 onClick={() => scrollTo(link)}
//                 className="px-4 py-2 text-sm font-medium text-gray-800 rounded hover:text-blue-600 hover:bg-blue-50 transition-all duration-200"
//               >
//                 {link}
//               </button>
//             </li>
//           ))}
//         </ul>

//         {/* CTA */}
//         <a
//           href="#appointment"
//           className="hidden md:inline-block bg-blue-600 text-white px-5 py-2.5 rounded text-sm font-medium hover:bg-blue-800 transition-colors duration-200"
//         >
//           Make Appointment
//         </a>

//         {/* Mobile Hamburger */}
//         <button
//           className="md:hidden text-gray-700 focus:outline-none"
//           onClick={() => setMenuOpen(!menuOpen)}
//         >
//           <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//             {menuOpen ? (
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//             ) : (
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
//             )}
//           </svg>
//         </button>
//       </div>

//       {/* Mobile Menu */}
//       {menuOpen && (
//         <div className="md:hidden bg-white border-t border-gray-100 px-6 pb-4">
//           {navLinks.map((link) => (
//             <button
//               key={link}
//               onClick={() => scrollTo(link)}
//               className="block w-full text-left py-2.5 text-sm font-medium text-gray-700 hover:text-blue-600 border-b border-gray-50"
//             >
//               {link}
//             </button>
//           ))}
//           <a
//             href="#"
//             className="mt-3 block text-center bg-blue-600 text-white px-5 py-2.5 rounded text-sm font-medium"
//           >
//             Make Appointment
//           </a>
//         </div>
//       )}
//     </nav>
//   );
// };

// export default Navbar;


import React, { useState, useEffect, useRef } from "react";
import logo from "../assets/logo.png";

const defaultMainNavLinks = [
  { label: "Home", id: "home" },
  { label: "About", id: "about" },
  { label: "Patient Care", id: "patient-care" },
  { label: "Network", id: "network" },
  { label: "Wellness", id: "wellness" },
  { label: "Booking", id: "bookings" },
  { label: "AI Channel", id: "ai-channel" }
];

const aiChannelNavLinks = [
  { label: "Network", id: "network" },
  { label: "Wellness", id: "wellness" },
  { label: "Booking", id: "bookings" },
  { label: "AI Channel", id: "ai-channel" },
  { label: "Latest News", id: "news-achievements" },
  { label: "Partnerships", id: "partnerships" },
  { label: "Contact", id: "contact" }
];

const allNavLinks = [
  { label: "Home", id: "home" },
  { label: "About", id: "about" },
  { label: "Patient Care", id: "patient-care" },
  { label: "Network", id: "network" },
  { label: "Wellness", id: "wellness" },
  { label: "Booking", id: "bookings" },
  { label: "AI Channel", id: "ai-channel" },
  { label: "Latest News", id: "news-achievements" },
  { label: "Partnerships", id: "partnerships" },
  { label: "Contact", id: "contact" }
];

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("home");
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      let currentSection = "home";
      
      for (const link of allNavLinks) {
        const section = document.getElementById(link.id);
        if (section) {
          const rect = section.getBoundingClientRect();
          if (rect.top <= 100) {
            currentSection = link.id;
          }
        }
      }
      
      setActiveSection(currentSection);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  // Determine which nav items to show based on active section
  const isOnExtendedNav = ["ai-channel", "news-achievements", "partnerships", "contact"].includes(activeSection);
  const visibleNavItems = isOnExtendedNav ? aiChannelNavLinks : defaultMainNavLinks;

  return (
    <>
      <style>{`
        .nav-link {
          position: relative;
          overflow: hidden;
          transition: all 0.3s ease;
        }

        .nav-link::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
          transition: left 0.5s ease;
        }

        .nav-link:hover::before {
          left: 100%;
        }

        .nav-link::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          width: 0;
          height: 2px;
          background: linear-gradient(90deg, #1A7A7A, #0D9DAD);
          transition: width 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
        }

        .nav-link:hover::after {
          width: 100%;
        }

        .nav-link:hover {
          color: #1A7A7A;
          text-shadow: 0 0 10px rgba(26, 122, 122, 0.3);
        }

        .nav-link.active {
          color: #1A7A7A;
          font-weight: 700;
          background: rgba(26, 122, 122, 0.1);
          border-radius: 8px;
          padding: 8px 12px;
        }

        .nav-link.active::after {
          width: 100%;
        }

        .mobile-item {
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }

        .mobile-item::before {
          content: '';
          position: absolute;
          left: -100%;
          top: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(26, 122, 122, 0.1), transparent);
          transition: left 0.5s ease;
        }

        .mobile-item:hover::before {
          left: 100%;
        }

        .mobile-item:hover {
          transform: translateX(8px);
          background: rgba(26, 122, 122, 0.1) !important;
          border-radius: 8px;
          box-shadow: inset 0 0 10px rgba(26, 122, 122, 0.1);
        }

        .mobile-item.active {
          background: rgba(26, 122, 122, 0.15) !important;
          box-shadow: inset 0 0 15px rgba(26, 122, 122, 0.2);
          transform: translateX(8px);
        }

        .cta-button {
          position: relative;
          overflow: hidden;
          transition: all 0.3s ease;
        }

        .cta-button::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
          transition: left 0.6s ease;
        }

        .cta-button:hover::before {
          left: 100%;
        }

        .cta-button:hover {
          transform: scale(1.05) translateY(-2px);
        }

        @keyframes buttonPulse {
          0%, 100% {
            box-shadow: 0 0 0 0 rgba(26, 122, 122, 0.7);
          }
          50% {
            box-shadow: 0 0 0 10px rgba(26, 122, 122, 0);
          }
        }

        .cta-button-animate {
          animation: buttonPulse 2s infinite;
        }
      `}</style>

      <nav className="bg-gradient-to-r from-teal-50 via-cyan-50 to-teal-50 shadow-lg sticky top-0 z-50 border-b-2 border-teal-200">
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-20 py-4">
          
          {/* Logo Section */}
          <div className="flex items-center cursor-pointer" onClick={() => scrollTo("home")}>
            <img 
              src={logo} 
              alt="HelaDoc Logo" 
              className="h-24 w-auto object-contain" 
            />
          </div>

          {/* Desktop Nav */}
          <ul className="hidden md:flex gap-8 list-none items-center">
            {visibleNavItems.map((link, idx) => (
              <li key={link.id} style={{ animationDelay: `${0.1 + idx * 0.05}s` }}>
                <button
                  onClick={() => scrollTo(link.id)}
                  className={`nav-link px-3 py-2 text-sm font-medium transition-colors duration-200 ${
                    activeSection === link.id
                      ? "active text-[#1A7A7A]"
                      : "text-gray-800 hover:text-[#1A7A7A]"
                  }`}
                  aria-label={`Navigate to ${link.label}`}
                >
                  {link.label}
                </button>
              </li>
            ))}
          </ul>

          {/* CTA Button */}
          <button 
            className="cta-button cta-button-animate hidden md:inline-flex items-center gap-2 bg-gradient-to-r from-[#1A7A7A] to-[#0D9DAD] text-white px-6 py-2.5 rounded-lg text-sm font-semibold shadow-lg shadow-[#1A7A7A]/30 hover:shadow-2xl hover:shadow-[#1A7A7A]/50 transform transition-all duration-300"
            aria-label="Book Now"
          >
            📅 Book Now
          </button>

          {/* Mobile Hamburger */}
          <button
            className="md:hidden text-gray-700 focus:outline-none"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle mobile menu"
            aria-expanded={menuOpen}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {menuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {menuOpen && (
          <div className="md:hidden bg-gradient-to-b from-slate-50 to-white border-t border-slate-200 px-6 pb-4 max-h-96 overflow-y-auto">
            {visibleNavItems.map((link, idx) => (
              <button
                key={link.id}
                onClick={() => scrollTo(link.id)}
                className={`mobile-item block w-full text-left py-3 px-4 text-sm font-medium rounded-lg transition-colors duration-200 ${
                  activeSection === link.id
                    ? "active bg-[#1A7A7A]/10 text-[#1A7A7A] font-bold"
                    : "text-gray-700 hover:text-[#1A7A7A]"
                }`}
                style={{ animationDelay: `${idx * 60}ms` }}
                aria-label={`Navigate to ${link.label}`}
              >
                {link.label}
              </button>
            ))}

            {/* Mobile CTA Button */}
            <button 
              className="cta-button w-full mt-4 inline-flex items-center justify-center gap-2 bg-gradient-to-r from-[#1A7A7A] to-[#0D9DAD] text-white py-2.5 rounded-lg text-sm font-semibold shadow-lg shadow-[#1A7A7A]/30 hover:shadow-2xl hover:shadow-[#1A7A7A]/50 transform transition-all duration-300"
              aria-label="Book Now"
            >
              📅 Book Now
            </button>
          </div>
        )}
      </nav>
    </>
  );
};

export default Navbar;